export enum ShareMenuActions {
  ShareLearnerLink = 'SHARE_LEARNER_LINK',
  ShareStaffLink = 'SHARE_STAFF_LINK',
  ShareContent = 'SHARE_CONTENT',
  OpenShareMenu = 'OPEN_SHARE_MENU',
  LearnerCopyLink = 'LEARNER_COPY_LINK',
}

export type ShareMenuActionProps = {
  showLearnerLink?: boolean;
  showLyearnConnect: boolean;
  canShare?: boolean;
};
